import { render } from "./SurvivalWorkingTips.vue?vue&type=template&id=42662fbe"
import script from "./SurvivalWorkingTips.vue?vue&type=script&lang=js"
export * from "./SurvivalWorkingTips.vue?vue&type=script&lang=js"

import "./SurvivalWorkingTips.vue?vue&type=style&index=0&id=42662fbe&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "42662fbe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42662fbe', script)) {
    api.reload('42662fbe', script)
  }
  
  module.hot.accept("./SurvivalWorkingTips.vue?vue&type=template&id=42662fbe", () => {
    api.rerender('42662fbe', render)
  })

}

script.__file = "src/views/SurvivalWorkingTips.vue"

export default script